import { render, staticRenderFns } from "./InternalAddress.vue?vue&type=template&id=5579c721&scoped=true"
import script from "./InternalAddress.vue?vue&type=script&lang=js"
export * from "./InternalAddress.vue?vue&type=script&lang=js"
import style0 from "./InternalAddress.vue?vue&type=style&index=0&id=5579c721&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5579c721",
  null
  
)

export default component.exports